export enum PaymentType {
  Rent = "rent",
  Insurance = "insurance",
  Discount = "discount",
  Establishment = "establishment",  
  Rounding = "rounding",
  Vat = "vat",
  RoundedAmount = "roundedAmount",
  RoundedVatAmount = "roundedVatAmount",
  Total = "total",
  DiscountVat = "discountVat",
}
